export default __webpack_public_path__ + "static/media/032-shopping bag.79e3a3b0.svg";